import { render, staticRenderFns } from "./city-select.vue?vue&type=template&id=591a0a64&scoped=true"
import script from "./city-select.vue?vue&type=script&lang=js"
export * from "./city-select.vue?vue&type=script&lang=js"
import style0 from "./city-select.vue?vue&type=style&index=0&id=591a0a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a0a64",
  null
  
)

export default component.exports